import apiClient from './apiClient'


const getProviders = (tenant) => {
  return apiClient.get(`/${tenant}/Provider`)
}


export default {
  getProviders
}
